import { render, staticRenderFns } from "./no-access.vue?vue&type=template&id=381d7a42"
import script from "./no-access.vue?vue&type=script&lang=js"
export * from "./no-access.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('381d7a42')) {
      api.createRecord('381d7a42', component.options)
    } else {
      api.reload('381d7a42', component.options)
    }
    module.hot.accept("./no-access.vue?vue&type=template&id=381d7a42", function () {
      api.rerender('381d7a42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/access/no-access.vue"
export default component.exports